// Import the package.json file and export the version
const packageInfo = require('../../package.json');

export const version = packageInfo.version;
export const appName = packageInfo.name;

// Function to get formatted version string (e.g., "v1.0.0")
export const getFormattedVersion = () => `v${version}`;

// Export default for convenience
export default version;
